<template>
  <div class="w-full">
    <CsTimeSettings :form-data="formData" />
    <FollowUpOrder :form-data="formData" />
    <EmailNotification :form-data="formData" />
    <MetaConversionTracking :form-data="formData" />
    <HumanHandover :form-data="formData" />
  </div>
</template>

<script>
import CsTimeSettings from './setting/CsTimeSettings.vue'
import HumanHandover from './setting/HumanHandover.vue'
import FollowUpOrder from './setting/FollowUpOrder.vue'
import EmailNotification from './setting/EmailNotification.vue'
import MetaConversionTracking from './setting/MetaConversionTracking.vue'

export default {
  name: 'StepFive',
  components: {
    CsTimeSettings,
    HumanHandover,
    FollowUpOrder,
    EmailNotification,
    MetaConversionTracking,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        is_off_when_manually: false,
        times: [],
        reminder: [],
        email_close_order: false,
        human_handover: {
          is_active: false,
          is_keyword_trigger: false,
          keywords: [],
          is_negative_sentiment: false,
          is_auto_return_cs_ai: false,
          auto_return_cs_ai_minutes: 15,
        },
        meta_capi_config: {
          is_active: false,
          pixel_name: '',
          pixel_id: '',
          access_token: '',
          event_test_code: '',
          is_connected: false,
          dataset_name: '',
          events: [],
          meta_events: [],
        },
      }),
    },
  },
}
</script>
